(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('RejectionReasonDialogController', RejectionReasonDialogController);

    RejectionReasonDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RejectionReason'];

    function RejectionReasonDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RejectionReason) {
        var vm = this;
        vm.rejectionReason = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:rejectionReasonUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.rejectionReason.id !== null) {
                RejectionReason.update(vm.rejectionReason, onSaveSuccess, onSaveError);
            } else {
                RejectionReason.save(vm.rejectionReason, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
